import React, { createContext, useState, useEffect } from 'react';

import useAuth from './hooks/useAuth';

const Context = createContext();

function AuthProvider({ children }) {
  const {
    authenticated, loading, handleLogin, handleLogout, userLogged, nome, email, roles
  } = useAuth();

  return (
    <Context.Provider value={{ authenticated, loading, handleLogin, handleLogout, userLogged, nome, email, roles }}>
      {children}
    </Context.Provider>
  );
}

export { Context, AuthProvider };
